import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Home, User, Settings } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { MobileNavigation } from './MobileNavigation';
import { SubscriptionGate } from './SubscriptionGate';

export const Layout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  // Check if current route is chat
  const isChatRoute = location.pathname.startsWith('/chat');

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Close sidebar when route changes on mobile
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  return (
    <SubscriptionGate>
      <div className="relative w-full h-full">
        {/* Desktop Sidebar - Fixed */}
        <div className="hidden lg:block fixed top-0 left-0 h-full z-40">
          <Sidebar />
        </div>

        {/* Main Content */}
        <div
          className={`transition-all duration-300 ${
            isChatRoute ? 'h-screen' : 'min-h-screen'
          } bg-kind-deep text-kind-text-primary ${isChatRoute ? 'lg:ml-20' : 'lg:ml-64'}`}
        >
          <div
            className={`flex flex-col ${
              isChatRoute ? 'h-full pb-0' : 'pb-20'
            } lg:pb-0 overflow-x-hidden`}
          >
            <Outlet />
          </div>
        </div>

        {/* Mobile Bottom Navigation - Hidden in chat and desktop */}
        {!isChatRoute && isMobile && <MobileNavigation />}
      </div>
    </SubscriptionGate>
  );
};
